import axios from '@/backend'

const state = {
  fields: [],
  loading: true
}

const getters = {
  fields (state) {
    return state.fields
  },
  field (state) {
    return (id) => {
      return state.fields.find(field => field.id === id)
    }
  },
  fieldsLoading (state) {
    return state.loading
  }
}

const mutations = {

  setFields (state, fields) {
    state.fields = fields
  },

  updateFields (state, field) {
    let index = state.fields.index(e => e.id === field.id)
    state.fields.splice(index, 1, field)
  },

  addCreatedField (state, field) {
    state.fields.push(field)
  },

  setLoading (state, loading) {
    state.loading = loading
  }
}

const actions = {
  loadFields ({dispatch, commit}, payload) {
    commit('setLoading', true)
    axios.get('/fields')
      .then(function (response) {
        commit('setFields', response.data)
        commit('setLoading', false)
      })
      .catch(e => { console.log(e) })
  },
  addField ({dispatch, commit}, field) {
    axios.post('/fields', {
      field: field
    })
      .then(response => {
        commit('addCreatedField', response.data)
      })
      .catch(e => console.log(e))
  },
  updateField ({dispatch, commit}, field) {
    axios.put(`/fields/${field.id}`, {
      field: field
    })
      .then(response => {
        commit('updateFields', response.data)
      })
      .catch(e => console.log(e))
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/fields.js